// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"b97e6a7a","604":"1d7119bc","730":"d07fbc6d","986":"d835bfa4"}[chunkId] + ".chunk.css";
};